// ToContactSection.jsx
import React from "react";
import "./ToContactSection.css";

import { motion } from "framer-motion";

const ToContactSection = () => {
  return (
    <motion.section
                  initial={{ opacity: 0, y: 80 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, ease: "easeOut" }}
                  viewport={{ once: false, amount: 0.3 }}
                >
    <section className="to-contact-section">
      <div className="tca-container">
        <h2 className="headline">
          Through the years we helped a lot of companies.
        </h2>
        <p className="subheading">
          Are you ready to become our partner?
        </p>
        <a href="/contact" className="cta-button-to">
          Get in Touch
        </a>
      </div>
    </section>
    </motion.section>
  );
};

export default ToContactSection;